import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  TemplateBaseWrapper
} from './styled'

export class TemplateBase extends React.PureComponent {
  render () {
    const {
      children,
      className
    } = this.props

    return (
      <TemplateBaseWrapper
        className={ClassNames(
          'template-base',
          className
        )}
      >
        {children}
      </TemplateBaseWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
